import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import KnowledgeBaseSelect from "@/components/common/KnowledgeBaseSelect";
import { useState } from "react";

export interface SlackChannelFormData {
  name: string;
  slackKey?: string;
  slackPrivateKey?: string;
  knowledgeBaseIds?: string[];
}

interface SlackChannelFormProps {
  initialName?: string;
  initialSlackKey?: string;
  initialSlackPrivateKey?: string;
  initialKnowledgeBaseIds?: string[];
  onClose: () => void;
  onSave: (data: SlackChannelFormData) => void;
}

export default function SlackChannelForm({
  initialName = "",
  initialSlackKey = "",
  initialSlackPrivateKey = "",
  initialKnowledgeBaseIds = [],
  onClose,
  onSave,
}: SlackChannelFormProps) {
  const [name, setName] = useState(initialName);
  const [slackKey, setSlackKey] = useState(initialSlackKey);
  const [slackPrivateKey, setSlackPrivateKey] = useState(initialSlackPrivateKey);
  const [knowledgeBaseIds, setKnowledgeBaseIds] = useState<string[]>(initialKnowledgeBaseIds || []);
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) return;
    setSaving(true);
    try {
      onSave({ name: name.trim(), slackKey: slackKey || undefined, slackPrivateKey: slackPrivateKey || undefined, knowledgeBaseIds });
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="p-6 space-y-4">
      <div className="space-y-2">
        <Label htmlFor="name">Nome do canal</Label>
        <Input
          id="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Ex: Suporte Slack"
          required
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="slackKey">Slack Key (opcional)</Label>
        <Input
          id="slackKey"
          value={slackKey}
          onChange={(e) => setSlackKey(e.target.value)}
          placeholder="xoxb-..."
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="slackPrivateKey">Slack Private Key (opcional)</Label>
        <Input
          id="slackPrivateKey"
          type="password"
          value={slackPrivateKey}
          onChange={(e) => setSlackPrivateKey(e.target.value)}
        />
      </div>
      <div className="space-y-2">
        <Label>Base de conhecimento (opcional)</Label>
        <KnowledgeBaseSelect
          selectedKnowledgeBases={knowledgeBaseIds}
          onChange={setKnowledgeBaseIds}
        />
      </div>
      <div className="flex justify-end gap-2 pt-4">
        <Button type="button" variant="outline" onClick={onClose}>
          Cancelar
        </Button>
        <Button type="submit" disabled={saving || !name.trim()}>
          {saving ? "Salvando..." : "Salvar"}
        </Button>
      </div>
    </form>
  );
}
